module.exports = __webpack_public_path__ + "images/avatars/male/13.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/13.svg
// module id = XMqc
// module chunks = 153